import { Injectable } from '@angular/core';
import { Utymc } from '../entity/Utymc-angular';
import { UtymcServicePkg } from './utymcPkg.service';


@Injectable({
  providedIn: 'root'
})
export class UtymcService extends UtymcServicePkg {
  constructor() {
    super();
    if(this.login.CUSTOMER==='JACK'){
      this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    }else{
      this.sqlWhereDefault = `/*WHERE*/ WHERE MC020='${this.login.CUSTOMER}'`;
    }
  }
  override async validateItem(item: Utymc): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

override async newRecord(newItem: Utymc): Promise<Utymc> {
    await super.newRecord(newItem);
    newItem.MC020 = this.login.CUSTOMER;
    newItem.MC001 = this.login.CUSTOMER;
    newItem.MC002 = '0001';
        const ret = await this.orm.autoNo(
      'master',
      'UTYMC',
      this.keyFields.join(','),
      this.item.MC001 ,
      '',
      4,
    );
    newItem.MC003 = ret.data;
    return newItem;
  }
}
